import {
    History
} from "lucide-react";

function OrderHistoryHeader() {

    return (

        <div style={styles.header}>

            <h1 style={styles.title}>

                <History
                    size={38}
                    color="#00ff88"
                />

                Order History

            </h1>

            <p style={styles.subtitle}>

                View your past bookings
                and invoices

            </p>

        </div>
    );
}

const styles = {

    header: {

        marginBottom: "32px",
    },

    title: {

        display: "flex",

        alignItems: "center",

        gap: "16px",

        color: "#fff",

        fontSize: "38px",

        fontWeight: "800",

        margin: 0,
    },

    subtitle: {

        color: "#cbd5e1",

        fontSize: "15px",

        marginTop: "6px",
    },
};

export default OrderHistoryHeader;